import { useQuery, useQueryClient } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getReviewPeriodSummaryGoals } from 'services/performanceReview';

export const useReviewPeriodSummaryOkrs = ({ reviewId, employeeId }) =>
  useQuery(
    [REACT_QUERY_KEYS.ReviewPeriodSummaryOkrs, reviewId, employeeId],
    () =>
      getReviewPeriodSummaryGoals({
        reviewId,
        employeeId,
      }),
    { enabled: !!(employeeId && reviewId) }
  );

export const useInvalidateReviewPeriodSummaryOkrs = ({ reviewId, employeeId }) => {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries([REACT_QUERY_KEYS.ReviewPeriodSummaryOkrs, reviewId, employeeId]);
};
